import React from 'react';
import Self from '../assets/img/pp2.jpg';
import { motion } from 'framer-motion';
import GlassButton from './GlassButton';
import Typewriter from './Typewriter';

const About = () => {
  const handleDitherPointerMove = (event) => {
    const { left, top, width, height } = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - left) / width) * 100;
    const y = ((event.clientY - top) / height) * 100;
    const driftX = ((x - 50) / 50) * 8;
    const driftY = ((y - 50) / 50) * 8;

    event.currentTarget.style.setProperty('--dither-x', `${x}%`);
    event.currentTarget.style.setProperty('--dither-y', `${y}%`);
    event.currentTarget.style.setProperty('--dither-drift-x', `${driftX}px`);
    event.currentTarget.style.setProperty('--dither-drift-y', `${driftY}px`);
  };

  return (
    <section className='section bg-secondary' id='about'>
      <div className='container mx-auto'>

        <div
          className='about-content-panel flex flex-col xl:flex-row gap-16 xl:gap-24 items-center xl:items-start'
          onPointerMove={handleDitherPointerMove}
          onPointerLeave={(event) => {
            event.currentTarget.style.setProperty('--dither-x', '50%');
            event.currentTarget.style.setProperty('--dither-y', '50%');
            event.currentTarget.style.setProperty('--dither-drift-x', '0px');
            event.currentTarget.style.setProperty('--dither-drift-y', '0px');
          }}
        >

          {/* ── Photo ── */}
          <motion.div
            className='flex-shrink-0'
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <div className='about-photo-frame'>
              <img
                className='about-photo'
                src={Self}
                alt='Seth Nuzum'
                loading='lazy'
                decoding='async'
              />
            </div>
          </motion.div>

          {/* ── Text ── */}
          <motion.div
            className='flex flex-col items-center text-center lg:items-start lg:text-left flex-1'
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
          >
            <span className='section-eyebrow'> </span>

            <h2 className='text-3xl lg:text-4xl font-extrabold mb-4 mt-2'>
              About me
            </h2>

            <p className='mb-6 text-accent min-h-[1.6em]'>
              <Typewriter
                phrases={[
                  'Software engineer.',
                  'Machine learning specialist.',
                  'Augmented reality builder.',
                ]}
                typeSpeed={62}
                deleteSpeed={30}
                pauseMs={2400}
              />
            </p>

            <div className='about-divider' />

            <p className='mb-8 text-paragraph leading-relaxed max-w-[520px]'>
              Most of my engineering efforts are focused on machine learning,
              deep learning, and developing state-of-the-art Augmented Reality
              software.
              <br /><br />
              In my free time I enjoy 3D printing, playing a bit of chess,
              reading some mind-bending sci-fi, and firing up my open-backs
              for some synth listening&nbsp;:)
            </p>

            <GlassButton
              onClick={() => (window.location = 'mailto:seth141592@gmail.com')}
              width={240}
              height={54}
              glassProps={{ backgroundOpacity: 0.06, displace: 8 }}
            >
              Shoot me an email
            </GlassButton>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;
